import { FC } from "react";

import Link, { LinkProps } from "@mui/material/Link";

type MuiLinkProps = LinkProps & {
  component?: string;
  disabled?: boolean;
  dataTestId?: string;
  isOpenNewTab?: boolean;
  href?: string;
};

export const MuiLink: FC<MuiLinkProps> = (props) => {
  const {
    className,
    disabled,
    tabIndex = 0,
    dataTestId,
    isOpenNewTab,
    href,
    ...rest
  } = props;
  return (
    <Link
      data-testid={dataTestId}
      className={`${className} ${disabled && "disabled"}`}
      tabIndex={tabIndex}
      role="link"
      {...(isOpenNewTab && { target: "_blank" })}
      {...(href && { href })}
      {...rest}
    />
  );
};
